import { Component, OnInit, Input, AfterViewInit, SimpleChanges, OnDestroy } from '@angular/core';
import { DispatchBoardService } from '@app/cp/shared/services/dispatch-board.service';
import { DispatchBoardPanels } from '@app/cp/shared/enums/DispatchBoardPanels';
import { Time } from '@angular/common';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { Subscription } from 'rxjs';
import { v_DispatchGrid2Bus } from '@app/cp/shared/models/v_DispatchGrid2Bus';
import { DragParent } from '@app/cp/shared/enums/DragParent';

@Component({
    selector: 'cp-cal-hour',
    templateUrl: './cal-hour.component.html',
    styleUrls: ['./cal-hour.component.scss']
})
export class CalHourComponent implements OnInit {

    subscriptions: Subscription[] = [];

    constructor(private svc_data: DispatchBoardService) {
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.initData();
            }));
        this.subscriptions.push(svc_data.calendarWeekData$.subscribe(
            calendar => {

                //this.initData();
            }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe(
            dispatch => {
                this.selectedDispatch = dispatch;
            }));
    }

    @Input() date: Date;
    @Input() time: number;
    inputTime: Date;
    startTime: Date = new Date();
    endTime: Date = new Date();
    assignments: DispatchAssignmentBus[] = [];
    dispatches: v_DispatchBus[] = [];
    assignmentSub: Subscription;
    dispatchSub: Subscription;

    selectedDispatch: string = '';

    public panelTypes = DispatchBoardPanels;
    panelType: DispatchBoardPanels = DispatchBoardPanels.tech;

    ngOnInit() {
        this.initData();
    }

    ngAfterViewInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.date.currentValue != changes.date.previousValue && !changes.date.firstChange) {
            this.initData();
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    initData() {

        this.assignments = [];
        this.dispatches = [];
        if (this.assignmentSub) {
            this.assignmentSub.unsubscribe();
        }
        if (this.dispatchSub) {
            this.dispatchSub.unsubscribe();
        }
        if (this.date && this.time) {
            this.setBoundaries(this.date, this.time);
        }
        this.populateCal();
    }

    setBoundaries(date: Date, time: any) {
        this.inputTime = new Date();
        this.inputTime.setTime(this.time);
        let hour = this.inputTime.getHours();
        this.startTime.setTime(date.getTime());
        //this.startTime.setUTCHours(hour, 0, 0, 0);
        this.startTime.setHours(hour, 0, 0, 0);
        this.endTime.setTime(date.getTime());
        //this.endTime.setUTCHours(hour + 1, 0, 0, 0);
        this.endTime.setHours(hour + 1, 0, 0, 0);
    }

    populateCal() {
        this.date.setHours(0, 0, 0, 0);
        if (this.svc_data.techDispatches.length != 0) {
            for (var i = 0; i < this.svc_data.techAssignments.length; i++) {
                if (this.svc_data.techAssignments[i].startDate >= this.startTime && this.svc_data.techAssignments[i].startDate < this.endTime) {
                    this.assignments.push(this.svc_data.techAssignments[i]);
                }
            }
            if (this.assignments.length != 0) {
                for (var i = 0; i < this.assignments.length; i++) {
                    this.dispatches.push(this.svc_data.techDispatches[this.svc_data.techDispatches.findIndex(dispatch => dispatch.dispatchId === this.assignments[i].dispatchId)]);
                }

            }
        } else {
            this.dispatchSub = this.svc_data.dispatchesForTech$.subscribe(
            dispatches => {
                this.initData();
            });
        }

    }

    openWindow(dispatch, trigger) {
        let passedData;
        let windowData;
        //alert(JSON.stringify(dispatch));
        //switch (trigger) {
        //    case 1:
        //        passedData = { data: this.svc_data.statusList, moveDispatch: dispatch };
        //        windowData = { contentType: this.contentTypes.moveStatus, boardData: passedData };

        //        this.openRequest.emit(windowData);
        //        break;
        //    case 2:
        //        passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
        //        windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };

        //        this.openRequest.emit(windowData);
        //        break;
        //    case 3:
        //        passedData = { data: {}, viewDispatch: dispatch };
        //        windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

        //        this.openRequest.emit(windowData);
        //        break;
        //}

    }

    dispatchDragging(e, index) {
        this.svc_data.setDragParent(2);
        this.svc_data.setSelectedAssignment(this.assignments[index].dispatchAssignmentId);
        this.svc_data.setSelectedDispatch(this.dispatches[index].dispatchId);
        this.svc_data.dispatchDragging(e.dispatch, e.dragState, DragParent.techCalendar);
    }

    setSelectedDispatch(dispatch: v_DispatchGrid2Bus) {

        this.svc_data.setSelectedDispatch(dispatch.dispatchId);
    }

    //setSelectedDispatch(dispatch: v_DispatchGrid2Bus) {
    //
    //    this.svc_data.setDragParent(2);
    //    this.svc_data.setSelectedAssignment();
    //    this.svc_data.setSelectedDispatch(dispatch.dispatchId);
    //}
}
